import { useReducer } from 'react';
import { createContainer } from 'unstated-next';
const applyUpdate = (action, state) => {
    const updateType = action.payload.updateType || 'set';
    let newDesiredState = Object.assign({}, action.payload.newState);
    if (updateType === 'update') {
        newDesiredState = Object.assign(Object.assign({}, state.desiredState), action.payload.newState);
    }
    return newDesiredState;
};
const initialState = {
    archivedSequences: [],
    sequenceQueue: [],
    currentSequence: undefined,
    desiredState: {},
    usedFacts: {}
};
const sequencePrioritySort = (seqA, seqB) => {
    if (seqA.priority === seqB.priority) {
        return (seqA.triggerDate ? 1 : 0) - (seqB.triggerDate ? 1 : 0);
    }
    // priorityNumber
    // date
    return seqB.priority - seqA.priority;
};
const addSequences = (sequences, newSequences, date) => {
    let updatedQueue = [...sequences];
    for (const sequence of newSequences) {
        if (sequence.priority === 2) {
            updatedQueue = updatedQueue.filter(({ priority }) => priority <= 2);
            updatedQueue.push(Object.assign(Object.assign({}, sequence), { triggerDate: date }));
        }
        else {
            updatedQueue.push(Object.assign(Object.assign({}, sequence), { triggerDate: date }));
        }
    }
    updatedQueue = updatedQueue.sort(sequencePrioritySort);
    return updatedQueue;
};
function reducer(state, action) {
    const date = new Date();
    switch (action.type) {
        case 'IGNORE_GUARDED_TRANSITION':
            // pull all transitions after that into the current point
            if (action.payload.index === state.currentSequence.transitions.length - 1) {
                return Object.assign(Object.assign({}, state), { currentSequence: null, archivedSequences: [
                        ...state.archivedSequences,
                        Object.assign(Object.assign({}, state.currentSequence), { finishedDate: date })
                    ] });
            }
            return Object.assign(Object.assign({}, state), { currentSequence: Object.assign(Object.assign({}, state.currentSequence), { lastBlockedIndex: action.payload.index }) });
        case 'APPLY_MANUAL_STATE':
            return Object.assign(Object.assign({}, state), { desiredState: action.payload });
        case 'APPLY_TRANSITION':
            return Object.assign(Object.assign({}, state), { desiredState: applyUpdate(action, state), currentSequence: Object.assign(Object.assign({}, state.currentSequence), { transitions: [
                        ...state.currentSequence.transitions.slice(0, action.payload.index),
                        [...state.currentSequence.transitions[action.payload.index], date],
                        ...state.currentSequence.transitions.slice(action.payload.index + 1)
                    ] }) });
        case 'APPLY_LAST_TRANSITION':
            return Object.assign(Object.assign({}, state), { desiredState: applyUpdate(action, state), currentSequence: null, archivedSequences: [
                    ...state.archivedSequences,
                    Object.assign(Object.assign({}, state.currentSequence), { finishedDate: date, transitions: [
                            ...state.currentSequence.transitions.slice(0, action.payload.index),
                            [...state.currentSequence.transitions[action.payload.index], date],
                            ...state.currentSequence.transitions.slice(action.payload.index + 1)
                        ] })
                ] });
        case 'UPDATE_CURRENT_SEQUENCE':
            return Object.assign(Object.assign({}, state), { currentSequence: Object.assign(Object.assign({}, action.payload), { startedDate: date }), sequenceQueue: state.sequenceQueue.filter(sequence => sequence !== action.payload), archivedSequences: state.currentSequence
                    ? [...state.archivedSequences, Object.assign(Object.assign({}, action.payload), { finishedDate: date })]
                    : state.archivedSequences });
        case 'ENQUEUE_NEW_SEQUENCES':
            //  this needs to handle wiped
            return Object.assign(Object.assign({}, state), { usedFacts: Object.assign(Object.assign({}, state.usedFacts), action.payload.reduce((all, { triggeringFactId }) => {
                    if (triggeringFactId) {
                        all[triggeringFactId] = true;
                    }
                    return all;
                }, {})), sequenceQueue: addSequences(state.sequenceQueue, action.payload, date) });
        default:
            throw new Error();
    }
}
export const useGfxState = () => {
    const [state, dispatch] = useReducer(reducer, initialState);
    return { state, dispatch };
};
export const DesiredGfxState = createContainer(useGfxState);
//# sourceMappingURL=useGfxState.js.map